import { render, staticRenderFns } from "./SettingsPane.vue?vue&type=template&id=d632d0a0&scoped=true&"
import script from "./SettingsPane.vue?vue&type=script&lang=js&"
export * from "./SettingsPane.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPane.vue?vue&type=style&index=0&id=d632d0a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d632d0a0",
  null
  
)

export default component.exports